import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FaBars, FaTimes } from "react-icons/fa";
import "./Navbar.css";
import logo from "../images/ignosilogo.webp";
import LeadPopup from "./LeadPopup";

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <nav className="navbarrrrr">
        <div className="nav-container">

          <div className="logo">
            <Link to="/" onClick={() => setIsOpen(false)}>
              {/* <img src="/ignosilogo.webp" alt="IGNOSI Logo" className="logo-img" /> */}
              <img src={logo} className="logo-img" alt="2" />
            </Link>
          </div>

          <div className="mobile-toggle" onClick={toggleMenu}>
            {isOpen ? <FaTimes /> : <FaBars />}
          </div>

          <div className={`nav-menu ${isOpen ? "active" : ""}`}>
            <ul className="nav-links">
              {/* <li><Link to="/" onClick={() => setIsOpen(false)}>Core Banking</Link></li> */}
              {/* <li><Link to="/solutions" onClick={() => setIsOpen(false)}>Solutions</Link></li> */}


              <li
                className="dropdown partners-dropdown"
                onMouseEnter={() => window.innerWidth > 992 && setIsOpen(false)}
              >
                <div className="dropdown-trigger">
                  Solutions
                  <span className="arrow">▾</span>
                </div>

                <div className="mega-menu">

                  <div className="mega-content">

                    <div className="mega-column">
                      <h4>SOFTWARE SOLUTIONS</h4>
                      <Link to="/nbfc">Ignosi BanQ | NBFC Software</Link>
                      <Link to="/mscs">Ignosi Co-op | Multi State Software</Link>
                      <Link to="/kml">Ignosi kml | Money lending Software</Link>
                      <Link to="/chitty">Ignsoi Bid | Chit Fund Management Software</Link>
                      <Link to="/mfi">Ignosi Micro |  Micro Finance Software</Link>
                      <Link to="/fpcpage">Ignosi PC | Farmer Producer Company Software</Link>
                      <Link to="/jewel">Ignosi Hallmark | Jewellery Software</Link>
                      <Link to="/gcalc">Ignosi G-Calc | Gold Loan Software</Link>
                      <Link to="/nidhi"> Ignosi Alchemy | Nidhi Banking Software</Link>
                    </div>

                    <div className="mega-column">
                      <h4>MOBILE APPLICATIONS</h4>
                      <Link to="/mobileapps">Association management software & App</Link>
                      <Link to="/mobileapps">Payment Collection App</Link>
                      <h4>ONLINE WEB SERVICE MODULES</h4>
                      <Link to="/webservices">Fake Gold Case Detection</Link>
                      <Link to="/webservices">Auction Management</Link>
                      <Link to="/webservices">Arbitration Management</Link>
                      <Link to="/webservices">CRM Module</Link>
                      <Link to="/webservices">Auditor Module</Link>
                      <Link to="/webservices">Online Gold Loan Services</Link>
                      <Link to="/webservices">Customer ID Verification</Link>
                      <Link to="/webservices">Face Image Verification</Link>
                      <Link to="/ignosisolution">Online Payment Collection</Link>
                    </div>

                  </div>
                </div>
              </li>

              {/* <li><Link to="/">Customers</Link></li> */}

              <li
                className="dropdown customers-dropdown"
                onMouseEnter={() => window.innerWidth > 992 && setIsOpen(false)}
              >
                <div className="dropdown-trigger">
                  Customers
                  <span className="arrow">▾</span>
                </div>

                <div className="mega-menu">

                  <div className="mega-content">

                    <div className="mega-column">
                      <h4>WHO WE SERVE</h4>
                      {/* <Link to="/banks">Banks</Link> */}
                      <Link to="/#whoweserve">Banks</Link>
                      <Link to="/#whoweserve">Neobanks</Link>
                      <Link to="/#whoweserve">Lenders</Link>
                      <Link to="/#whoweserve">Fintechs</Link>
                      <Link to="/#whoweserve">Credit Unions</Link>
                    </div>

                    <div className="mega-column">
                      <h4>USE CASES</h4>
                      <Link to="/#usecases">Banking-as-a-Service</Link>
                      <Link to="/#usecases">Buy Now Pay Later</Link>
                      <Link to="/#usecases">Embedded Finance</Link>
                      <Link to="/#usecases">Digital Lending</Link>
                      <Link to="/#usecases">Gold & Asset Finance</Link>
                    </div>

                  </div>

                </div>
              </li>
              {/* <li><Link to="/">Partners</Link></li> */} <li className="dropdown partners-mega" onMouseEnter={() => window.innerWidth > 992 && setIsOpen(false)} >
                <div className="dropdown-trigger"> Partners <span className="arrow">▾</span>
                </div>
                <div className="mega-menu">
                  <div className="mega-content">
                    <div className="mega-column">
                      <h4>TECHNOLOGY</h4>
                      <Link to="/partners">AWS</Link>
                      <Link to="/partners">Google Cloud</Link>
                      {/* <Link to="/partners">Microsoft Azure</Link> */}
                      <Link to="/partners">Cloudflare</Link>
                      <Link to="/partners">Docker</Link>
                      <Link to="/partners">Digital Ocean</Link>
                      <h4>PAYMENTS & BANKING</h4>
                      <Link to="/partners">Razorpay</Link>
                      <Link to="/partners">Cashfree</Link>
                      <Link to="/partners">SIB</Link>
                      <Link to="/partners">I Serve u</Link>
                    </div>
                    <div className="mega-column">
                      
                    </div>
                    {/* <div className="mega-column">
                      <h4>SECURITY & COMPLIANCE</h4>
                      <Link to="/partners/mcafee">McAfee</Link>
                    </div> */}
                  </div>
                  <div className="mega-footer">
                    <Link to="/partners" className="view-partners-btn"> View Who We Partner With → </Link>
                  </div>
                </div>
              </li>

              <li><Link to="/news-events">News & Events</Link></li>
              <li><Link to="/careers">Career</Link></li>
              <li><Link to="/about">About us</Link></li>

            </ul>

            <div className="nav-actions">
              {/* <button className="nav-btn-outline">Login</button> */}
              <button
                className="nav-btn-pill"
                onClick={() => setIsPopupOpen(true)}
              >
                Get Started
              </button>
            </div>

          </div>

        </div>
      </nav>

      {/* ================= POPUP OUTSIDE NAV ================= */}
      <LeadPopup
        isOpen={isPopupOpen}
        onClose={() => setIsPopupOpen(false)}
      />
    </>
  );
}

export default Navbar;